var _rect, _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAttachmentFile(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 4,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.87868 5.87868C8.44129 5.31607 9.20435 5 10 5H18C18.2652 5 18.5196 5.10536 18.7071 5.29289L24.7071 11.2929C24.8946 11.4804 25 11.7348 25 12V24C25 24.7957 24.6839 25.5587 24.1213 26.1213C23.5587 26.6839 22.7957 27 22 27H10C9.20435 27 8.44129 26.6839 7.87868 26.1213C7.31607 25.5587 7 24.7957 7 24V8C7 7.20435 7.31607 6.44129 7.87868 5.87868ZM10 7C9.73478 7 9.48043 7.10536 9.29289 7.29289C9.10536 7.48043 9 7.73478 9 8V24C9 24.2652 9.10536 24.5196 9.29289 24.7071C9.48043 24.8946 9.73478 25 10 25H22C22.2652 25 22.5196 24.8946 22.7071 24.7071C22.8946 24.5196 23 24.2652 23 24V12.4142L17.5858 7H10Z",
    fill: "#781D7E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11 21C11 20.4477 11.4477 20 12 20H20C20.5523 20 21 20.4477 21 21C21 21.5523 20.5523 22 20 22H12C11.4477 22 11 21.5523 11 21Z",
    fill: "#781D7E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11 17C11 16.4477 11.4477 16 12 16H20C20.5523 16 21 16.4477 21 17C21 17.5523 20.5523 18 20 18H12C11.4477 18 11 17.5523 11 17Z",
    fill: "#781D7E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11 13C11 12.4477 11.4477 12 12 12H14C14.5523 12 15 12.4477 15 13C15 13.5523 14.5523 14 14 14H12C11.4477 14 11 13.5523 11 13Z",
    fill: "#781D7E"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18 5C18.5523 5 19 5.44772 19 6V11H24C24.5523 11 25 11.4477 25 12C25 12.5523 24.5523 13 24 13H18C17.4477 13 17 12.5523 17 12V6C17 5.44772 17.4477 5 18 5Z",
    fill: "#781D7E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttachmentFile);
export default __webpack_public_path__ + "static/media/attachment_file.e22398c75cb6edeac6075330766f00c4.svg";
export { ForwardRef as ReactComponent };